import React from 'react';
export function About() {
  return <section id="about" className="bg-paper" data-id="element-10" data-mp="flijiwqi6ytq">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 py-20 md:py-24" data-id="element-11" data-mp="2pr7330ikjdz4">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-12" data-mp="2tt25k8c8jxeh">
          <div className="lg:col-span-5" data-id="element-13" data-mp="2triqgl2bfsea">
            <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-14" data-mp="2yrwy420090bs">
              About Craig
            </p>
            <h2 className="mt-4 font-serif text-3xl md:text-[2.5rem] leading-tight tracking-tight text-ink" data-id="element-15" data-mp="33qqdjzyur1el">
              Calm leadership. Practical progress.
            </h2>
          </div>

          <div className="lg:col-span-7 lg:pt-9" data-id="element-16" data-mp="3dicijeklk48w">
            <div className="space-y-5 text-lg leading-relaxed text-ink-soft max-w-2xl" data-id="element-17" data-mp="3himz1l60md20">
              <p data-id="element-18" data-mp="3hkhbeb380wuh">
                I’ve led across business operations, international expansion, government programs,
                and mission-driven organizations. I’m drawn to complicated situations where the work
                matters and the path forward needs to become clearer.
              </p>
              <p data-id="element-19" data-mp="2gs4caiqentte">
                I get into the details, help people make decisions, and stay involved through
                implementation. Where it helps, I use AI and automation to accelerate the work.
              </p>
            </div>
            <p className="mt-8 pl-5 border-l-2 border-forest font-serif text-xl md:text-2xl leading-snug text-ink max-w-2xl" data-id="element-20" data-mp="27shh4eo9rk8s">
              My goal is to leave your team more capable of succeeding without me.
            </p>
          </div>
        </div>
      </div>
    </section>;
}